import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-DuplicateNotification',
	section: 'c-DuplicateNotification__section',
	title: 'c-DuplicateNotification__title',
	content: 'c-DuplicateNotification__content',
	modal: 'c-DuplicateNotification__modal',
};

export const Style = {
	[CSS.container]: {
		color: DefaultTheme.font.color.primary,
	},
	[CSS.section]: {
		'padding-bottom': DefaultTheme.space(1),
	},
	[CSS.title]: {
		'font-weight': DefaultTheme.font.weight.bold,
	},
	[CSS.content]: {
		'list-style': 'none',
		margin: 0,
	},
	[CSS.modal]: {
		'min-width': '650px',
	},
};
